module.exports = "<div class=\"c-tabs-content\">\n    <slot></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/tabs-content/tabs-content.vhtml
// module id = 314
// module chunks = 0